// extracted by mini-css-extract-plugin
export var footerContainer = "N_cx";
export var footerContent = "N_cz";
export var footerDisclosure = "N_cB";
export var menu = "N_cy";